import { gsap } from 'gsap'

const sliderTween = function () {
    const slide_tl1 = new gsap.timeline({ repeat: -1 })

    slide_tl1

        .to('.slidetext1', 0.7, { yPercent: -50, autoAlpha: 0, delay: 2.5 })
        .fromTo('.slidetext2', 0.7, { yPercent: 50, opacity: 0, visibility: 'hidden' }, { yPercent: 0, opacity: 1, visibility: 'visible' })

        .to('.slidetext2', 0.7, { yPercent: -50, autoAlpha: 0, delay: 2.5 })

        .fromTo('.slidetext3', 0.7, { yPercent: 50, opacity: 0, visibility: 'hidden' }, { yPercent: 0, opacity: 1, visibility: 'visible' })

        .to('.slidetext3', 0.7, { yPercent: -50, autoAlpha: 0, delay: 2.5 })

        .set('.slidetext1', { yPercent: 50 })
        .to('.slidetext1', 0.7, { yPercent: 0, autoAlpha: 1 })
}

window.onload = function () {
    sliderTween()
}
